/* 모든 메뉴에서 공통으로 사용 */
// fetch
export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';
export const FETCH_ERROR = 'FETCH_ERROR';
export const FETCH_CANCEL = 'FETCH_CANCEL';// 아직 구현된 곳 없음

// 데이타 처리
export const GET_ONE = 'GET_ONE';

